var kind = require("enyo/kind");

/**
 * [EventListeningSupport]{@link enyo-canvas.EventListeningSupport} is a mixin
 * for a [CanvasControl]{@link enyo-canvas.CanvasControl} which automatically
 * registers and un-registers eventListeners on the scene.
 *
 * @mixin enyo-canvas.EventListeningSupport
 * @public
 */
module.exports = {

    /**
     * @private
     */
    name: "enyo-canvas.EventListeningSupport",

    /**
     * Automatically un-registers event handlers on the old scene and registers
     * them on the new scene
     *
     * @param    {?enyo-canvas.Canvas}  previousScene  The previous scene
     * @memberof enyo-canvas.EventListeningSupport
     * @method
     * @private
     */
    sceneChanged: kind.inherit(function(sup) {
        return function(previousScene) {
            var currentScene = this.scene,
                handlers     = this.eventHandlers || {},
                event;

            sup.apply(this, arguments);

            // Remove listeners from old scene
            if (previousScene && previousScene !== currentScene) {
                for (event in handlers) {
                    if (handlers.hasOwnProperty(event)) {
                        previousScene.removeEventListener(this, event);
                    }
                }
            }

            // Add listeners to new scene
            if (currentScene && currentScene !== previousScene) {
                for (event in handlers) {
                    if (handlers.hasOwnProperty(event)) {
                        currentScene.addEventListener(this, event, handlers[event]);
                    }
                }
            }

        };
    })

};
